<template>
  <v-app id='inspire'>
      <v-layout row class="justify-center">
        <v-flex xs12 md8>
          <v-layout align-center row class="my-3">
            <span v-if="tipo_usuario === 'usuario_externo'" class='txt-titulo'>         
              Declaración Jurada de Bienes y Rentas
            </span>
            <span v-if="tipo_usuario !== 'usuario_externo'" class='txt-titulo'>
              {{$t('comun.titulo')}}
            </span>
            <v-spacer/>
            <a v-if="!datosPersonalesExpandibles" @click="datosPersonalesExpandibles=true">
              <v-icon color="primary">person</v-icon>
              <v-icon color="primary">keyboard_arrow_down</v-icon>
            </a>
          </v-layout>
          <div v-if="datosPersonalesExpandibles" class="card-outlined px-3 pb-3 pt-2">
            <v-layout justify-end row>
              <v-icon @click="datosPersonalesExpandibles=false">close</v-icon>
            </v-layout>
            <v-layout class="align-center" row wrap>
              <v-flex xs12 md6>
                <v-layout class="my-2"><v-icon small color="primary">account_circle</v-icon>&nbsp;<span class="caption primary--text">{{$t('comun.nombre_completo')}}:</span></v-layout>
                <v-layout class="my-2"><span class="title font-weight-light">{{usuario.nombres}} {{usuario.primer_apellido}} {{usuario.segundo_apellido}}</span></v-layout>
              </v-flex>
              <v-flex xs12 md6>
                <v-layout class="my-2"><v-icon small color="primary">contacts</v-icon>&nbsp;<span class="caption primary--text">{{$t('comun.doc_identidad')}}:</span><br/></v-layout>
                <v-layout class="my-2"><span class="title font-weight-light">{{ usuario.nro_documento }}</span><br/></v-layout>
              </v-flex>
            </v-layout>
            <v-layout class="align-center my-2" v-if="usuario.email !== '' || usuario.celular !== ''" row wrap>
              <v-flex xs12 md6 v-if="usuario.email !== ''">
                <v-layout class="my-2"><v-icon small color="primary">mail_outline</v-icon>&nbsp;<span class="caption primary--text">{{$t('comun.email')}}:</span><br/></v-layout>
                <v-layout class="my-2"><span class="title font-weight-light word-break">{{ usuario.email }}</span></v-layout>
              </v-flex>
              <v-flex xs12 md6 v-if="usuario.celular !== ''">
                <v-layout class="my-2"><v-icon small color="primary">call</v-icon>&nbsp;<span class="caption primary--text">{{$t('comun.celular')}}:</span><br/></v-layout>
                <v-layout class="my-2"><span class="title font-weight-light">{{ usuario.celular }}</span></v-layout>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row justify-end min>
        <v-btn class="tamanioBoton" color='success' @click.stop="verificarEstadoDeclaracion()" v-show="this.estadoDeclaracion == -1">
        <v-icon small>card_membership</v-icon>&nbsp;{{$t('dashboard.primera_djbrd')}}
        </v-btn>
        <v-btn class="tamanioBoton" color="success" @click.stop="verificarEstadoDeclaracion()" v-show="this.estadoDeclaracion == 3">
          <v-icon small>card_membership</v-icon>&nbsp;{{$t('dashboard.nueva_djbrd')}}
        </v-btn>
        <v-btn class='continuar' @click.stop="$router.push('/datos-generales')" v-show="this.estadoDeclaracion == 1">
          <v-icon small>send</v-icon>&nbsp;{{$t('dashboard.continuar_djbrd')}}
        </v-btn>
        <div v-if="tipo_usuario !== 'usuario_externo' && estadoDeclaracion === 2">
          <v-btn class="tamanioBoton" color='warning' @click.stop="verificaHabilitacion()" v-show="this.estadoDeclaracion == 2">
            <v-icon small>done_all</v-icon>&nbsp;{{$t('dashboard.habilitar_djbrd')}}
          </v-btn>
          <v-btn class="tamanioBoton" color='success' @click.stop="$router.push('transaccion')" v-show="this.estadoDeclaracion == 2 && this.sistema_recepcion === 1">
            <v-icon small>thumb_up_alt</v-icon>&nbsp;Aprobar declaración
          </v-btn>
        </div>
        <div v-if="tipo_usuario === 'usuario_externo' && estadoDeclaracion === 2">
          <v-alert class="tamanioBoton" :value='true' type="warning">Tiene una declaración pendiente para recepcionar</v-alert>
          <v-dialog v-model="dialogHabilita" scrollable width="500">
            <template v-slot:activator="{ on }">
                <v-btn class="tamanioBoton" color='primary' v-on="on">
                    <v-icon small>visibility</v-icon>&nbsp;Ver detalles
                  </v-btn>
            </template>
            <v-card>
              <v-toolbar dark color='primary'>
                <v-toolbar-title><h4>Habilitación de Declaración</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogHabilita = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <br>
                <p align='justify'>Si su declaración todavia no ha sido recepcionada en oficinas de la Contraloría General del Estado, y usted desea modificar algún dato, su declaración 
                debe ser habilitado, para el mismo debe apersonarse a las oficinas Contraloría General del Estado para la habilitación correspondiente, de cuaquier forma puede re imprimir su formulario</p>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="$router.push('/transaccion')"><v-icon>print</v-icon><div class="tab-title-hab">&nbsp;imprimir documentos finalizados</div></v-btn>
                <v-btn color="error" text @click="dialogHabilita = false"><v-icon>cancel</v-icon>&nbsp;Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-layout>
      <v-dialog v-model="dialogAtencion" scrollable width="500">
        <v-card>
          <v-toolbar dark color='primary'>
            <v-toolbar-title><h4><v-icon>warning</v-icon> ATENCIÓN</h4></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogAtencion = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <br>
            <p align='justify'>
              Se ha identificado que tiene un Formulario <b>concluido en su llenado</b>, para continuar con la presentación digital del mismo, debe habilitar su Formulario, presionando la opción <b>(HABILITAR DECLARACIÓN)</b> luego nuevamente finalizar su llenado para posteriormente <b>APROBAR EL DOCUMENTO </b> 
              de su declaración mediante <b>CIUDADANÍA DIGITAL y de esta manera enviar la misma a la CGE.</b>
            </p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogAtencion = false"><v-icon>cancel</v-icon>&nbsp;Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <div>
        <v-flex sm9 md6 v-if='nro !== -1' class="my-0 py-0">
          <v-alert v-if='nro !== -1' class="tamanioBoton" :value='true' type='info' outline>La lista de declaraciones pertenece al documento de identidad: {{ usuario.nro_documento }}</v-alert>
        </v-flex>
      </div> -->
      <!-- <v-layout class="my-0 py-0">
        <v-flex sm9 md6 v-if='nro !== -1' class="my-0 py-0">
        </v-flex>
      </v-layout> -->
      <v-layout wrap>
        <v-flex sm12 md12 v-if='nro === 0'>
          <v-alert class="tamanioBoton" :value='true' color='info' icon='info'>Cargando...</v-alert>
        </v-flex>     
        <v-flex xs12>
            <v-layout>
              <v-alert v-if='nro !== -1' class="tamanioBoton mobile-disapear" :value='true' type='info' outline>La lista de declaraciones pertenece al documento de identidad: {{ usuario.nro_documento }}</v-alert>
              <v-spacer></v-spacer>
              <v-flex>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Búsqueda"
                  single-line
                  hide-details
                  autofocus
                  clearable
                  v-if='this.nro>0'
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              v-if='this.nro>0'
              :search="search"
              no-results-text="No se encuentran resultados de la búsqueda"
              :headers='headers'
              :items='datos'
              class='elevation-6'
              rows-per-page-text='Filas por página' 
              :rows-per-page-items="rowsPerPageItems">
              <template slot='no-data'>
                <v-alert class="tamanioBoton" :value='true' color='info' icon='info'>{{$t('comun.sin_informacion')}}</v-alert>
              </template>
              <template slot='items' slot-scope='props'>
                <td>{{ props.item.nro }}</td>
                <td class='justify-center layout px-0 mt-2 mb-2'>
                  <div v-show="(props.item['id_archivo_dig_form'] === '' || props.item['id_archivo_dig_form']=== null) && (props.item['id_archivo_dig_cert']=== '' || props.item['id_archivo_dig_cert']=== null)  && props.item['sistema_recepcion']===1 && props.item['decjur_estado']===3">
                    <!-- <v-btn @click="obtieneFirma(props.item)" :disabled="loading" class="mt-0" small color="primary">
                      {{$t('comun.firma_pendiente')}}
                    </v-btn> -->
                    <span style="position: relative; top: -3px; left: 20%;" class='mx-0'>RECEPCIONADO DIGITAL</span><br>
                    <v-btn style="position: relative; top: -4px; left: 5%;" @click="obtieneFirma(props.item)" :disabled="loading" class="mt-0" small color="primary">
                      ARCHIVOS EN PROCESO DE FIRMA
                    </v-btn>
                  </div>
                  <div v-show="props.item['sistema_recepcion'] === 0 && props.item['decjur_estado']===3">
                    <br/><p>RECEPCIÓN PRESENCIAL</p>
                  </div>
                  <div v-show="props.item['decjur_estado']===0">
                    <br/><p style="color:red;font-size:17px;"><b>DADO DE BAJA</b></p>
                  </div>
                  <div v-if="props.item['decjur_estado']===3 && props.item['sistema_recepcion'] === 1">
                  <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                      <v-btn :loading="loadingArchivos" icon v-on="on" class='mx-0' @click='getArchivoDigital(1, props.item["id_archivo_dig_form"], props.item["sha256_form"])' v-show="props.item['id_archivo_dig_form']>'0' || props.item['id_archivo_dig_form']>null">
                        <!-- <v-icon color='blue' :size='30'>cloud_download</v-icon> -->
                        <img width="26" src="../../assets/images/download_formulario.jpg"/>
                      </v-btn> 
                    </template>
                    <span>{{$t('dashboard.formulario')}}</span>
                  </v-tooltip>
                   <v-tooltip color="error" top>
                    <template v-slot:activator="{ on }">
                      <v-btn :loading="loadingArchivos" icon v-on="on"  class='mx-0' @click='getArchivoDigital(2,props.item["id_archivo_dig_cert"], props.item["sha256_cert"])' v-show="props.item['id_archivo_dig_cert']>'0' || props.item['id_archivo_dig_cert']>null">
                        <!-- <v-icon color='red' :size='30'>cloud_download</v-icon> -->
                        <img width="26" src="../../assets/images/download_certificado.jpg"/>
                      </v-btn>
                    </template>
                    <span>{{$t('dashboard.certificado')}}</span>
                  </v-tooltip>
                  </div>                                                   
                </td>             
                <td>{{ props.item.motdec_descripcion }}</td>
                <td>{{ props.item.cardec_descripcion_entidad }}</td>
                 <td>{{ props.item.cardec_descripcion_cargo }}</td>
                <td>{{ props.item.decjur_numero_certificado_departamento }} </td>  
                <td>{{ props.item.decjur_fecha_recepcion_formateado }}</td>
              </template>
              <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
            </v-data-table>
        </v-flex>
        <v-flex sm12 md12 v-if='nro === -1'>
            <v-alert
              class="tamanioBoton"
                :value='true'
                color='info'
                icon='info'     
              >{{$t('comun.sin_informacion')}}</v-alert>
        </v-flex>
      </v-layout>
      <!-- <v-layout align-center wrap>
      <v-flex md8 />
      <v-flex xs3 offset-xs9 align-end>
        <v-btn class="my-4" color="accent" @click="$router.push('/datos-generales')">Siguiente&nbsp;<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
      </v-flex>
    </v-layout> -->
      <v-layout>
        <v-dialog v-model='dialog' scrollable persistent max-width='700px'>
          <v-card>
            <v-toolbar dark color="primary" right>
                <v-toolbar-title><h4>{{$t('dashboard.nueva_djbrd_titulo')}}</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="clickCancelarDeclaracion()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-form v-model='valid' ref='form' lazy-validation>
                  <h4>{{$t('dashboard.datos_djbrd')}}:</h4>
                  <v-container>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md6>
                        <v-select
                        :no-data-text="$t('comun.sin_datos')"
                          v-model='motivoDeclaracion'
                          :items="motivoDeclaracionItems"
                          item-text='motdec_descripcion'
                          item-value='motdec_codigo'
                          label='Motivo de la Declaración*'
                          @change="obtenerDescripcionMotivoDeclaracion()"
                          :rules="dRules"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md6 v-if='oculatarCalendario'>
                        <global-date-input-picker
                          v-model="date" :hint="'Formato DD/MM/AAAA'" :rules="motivoDeclaracion === 7 ? dRules : true" label="Fecha de la Declaración a Rectificar*">
                        </global-date-input-picker> 
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs12 sm12 md12 v-if='this.motivoDeclaracion===7'>
                        <v-tooltip color="secondary" top>
                          <template v-slot:activator='{ on }'>
                           <v-textarea 
                              @change="observacionesRectificacion = $util.sanitiza(observacionesRectificacion)"
                              v-on='on'
                              v-model="observacionesRectificacion"
                              :label="$t('datos_generales.observacion')"
                              maxlength='250'
                              rows="1"
                              auto-grow
                              :counter='250'
                              hint='Máximo 250 caracteres.'
                              persistent-hint
                              :rules="motivoDeclaracion!==7 ? textRules : $validate(['text_area_required'])"
                              required
                            ></v-textarea>
                          </template>
                          <span>{{$t('datos_generales.observacion_span')}}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <div class="decretosBoton">
                          <v-menu bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-show='modificar' v-on="on" small tile outline color="primary">
                          <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                          </v-btn>
                      </template>
                      <v-card class="px-2 py-1">
                        <v-card-text class="black--text body-2">
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span align='justify'>{{this.motdecComentario}}</span>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                        </div>
                      <v-flex xs12 sm12 md12 class="decretos">
                        <v-alert class="tamanioBoton" :value='!!motivoDeclaracion' type='info' outline>{{this.motdecComentario}}</v-alert>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12 md2>
                        <p align='justify'>{{$t('datos_generales.declarar_como')}}</p>
                      </v-flex>
                      <v-flex xs12 md10>
                          <!-- <p>{{ declarar_como || 'null' }}</p> -->
                          <v-radio-group 
                            v-model='declararComo' 
                            :mandatory='false' 
                            row
                            @change="cambiaDpto()"
                            :rules="dRules"
                            required
                          >
                            <v-radio :label="$t('datos_generales.boliviano')" value='1'></v-radio>
                            <v-radio :label="$t('datos_generales.extranjero')" value='2'></v-radio>
                          </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap v-if="declararComo === '1' && tipo_usuario === 'usuario_externo'">
                      <v-flex sm6 md6>
                      <v-autocomplete 
                      :rules="dRules" 
                      :no-data-text='this.dato' 
                      v-model='codDepartamento.dep_codigo' 
                      :items="itemsDep" item-text="dep_descripcion" 
                      item-value="dep_codigo" label="Departamento donde Presentará su Declaración Jurada*"></v-autocomplete>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <div class="decretosBoton">
                          <v-menu bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-show='modificar' v-on="on" small tile outline color="primary">
                          <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                          </v-btn>
                      </template>
                      <v-card class="px-2 py-1">
                        <v-card-text class="black--text body-2">
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>{{$t('decretos.dec_1233_5')}}</span>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                        </div>
                      <v-flex xs12 md12 class="decretos">
                        <v-alert
                          class="tamanioBoton"
                          type='info'
                          outline
                        >{{$t('decretos.dec_1233_5')}}</v-alert>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12 md6 v-if="declararComo === '1'">
                        <p>{{$t('datos_generales.lugar_residencia')}}</p>
                      </v-flex>
                      <v-flex xs12 md4 v-if="declararComo === '1'">
                          <v-radio-group 
                            v-model='esCapital' 
                            :mandatory='false' 
                            row 
                            :rules="dRules"
                            required
                          >
                            <v-radio label='Si' value='1'></v-radio>
                            <v-radio label='No' value='2'></v-radio>
                          </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md6 v-if="declararComo === '1'">
                        <v-text-field
                          v-model='pais2'
                          :rules='dRules'
                          :label="$t('datos_generales.pais_residencia')"
                          required
                          box
                          readonly
                        ></v-text-field>
                      </v-flex>
                       <v-flex xs12 sm12 md6 v-if="declararComo === '2'">
                      <v-autocomplete
                          :no-data-text="$t('comun.sin_datos')"
                          v-model='pais'
                          :items='itemsPaises'
                          item-text='pai_descripcion'
                          item-value='pai_codigo'
                          :label="$t('datos_generales.pais_residencia')"
                          :rules='dRules'
                          required
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                       <v-text-field
                          v-model='localidad'
                          :rules='dRules'
                          maxlength="50"
                          :label="$t('datos_generales.localidad_residencia')"
                          required
                          @keyup="localidad = localidad ? localidad.replace(/[!°¬#$%&=?¿¡{}]/g, ''):''"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <div class="decretosBoton">
                          <v-menu bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-show='modificar' v-on="on" small tile outline color="primary">
                          <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                          </v-btn>
                      </template>
                      <v-card class="px-2 py-1">
                        <v-card-text class="black--text body-2">
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>{{$t('decretos.dec_1233_3')}}</span>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                        </div>
                      <v-flex xs12 md12 class="decretos">
                        <v-alert
                          class="tamanioBoton"
                          type='info'
                          outline
                        >{{$t('decretos.dec_1233_3')}}</v-alert>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-container>
               <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn :loading="loadingButton" class="tamanioBoton" color='primary' @click='clickGuardaDeclaracion()'>
                <v-icon>save</v-icon>&nbsp;{{$t('comun.guardar')}}
              </v-btn>
              <v-btn class="tamanioBoton" color='error' @click="clickCancelarDeclaracion()">
                <v-icon>cancel</v-icon>&nbsp;{{$t('comun.cancelar')}}
              </v-btn>
            </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout>
        <v-dialog v-model='dialogHabilitar' scrollable persistent max-width='700px'>
          <v-card>
            <v-toolbar dark color="primary" right>
                <v-toolbar-title v-if="bandera_habilitacion === 0"><h4>Confirmar Habilitar Declaración</h4></v-toolbar-title>
                <v-toolbar-title v-if="bandera_habilitacion === 1"><h4>Atención.</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogHabilitar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text v-if="bandera_habilitacion === 0">
              <p align="justify">
                Puede utilizar esta opción solo para habilitar cuando requiera realizar cambios en una DJBR finalizada en su llenado (no enviada a la CGE).
              </p>
              <p align="justify" style="color: red;">Si usted ha <b>"APROBADO"</b> con ciudadanía digital la DJBR para su envío a la CGE, 
                debe esperar la confirmación de la recepción por parte de la CGE, sin presionar la opción "HABILITAR DECLARACIÓN", caso contrario podría interrumpir el proceso y no se consolidaría su envío.
                </p>
              <p>{{$t('dashboard.mensaje_habilitar_djbrd')}}</p>
            </v-card-text>
            <v-card-text v-if="bandera_habilitacion === 1">
              <p align="justify">
                Tiene una declaración jurada finalizada en proceso de recepción, debe esperar a que se finalice el proceso para realizar la habilitación
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="bandera_habilitacion === 0" color='primary' @click='habilitarDeclaracion'>
                <v-icon>check</v-icon>&nbsp;Sí
              </v-btn>
              <v-btn v-if="bandera_habilitacion === 0" color='error' @click="dialogHabilitar=false">
                <v-icon>cancel</v-icon>&nbsp;No
              </v-btn>
              <v-btn v-if="bandera_habilitacion === 1" color='error' @click="dialogHabilitar=false">
                <v-icon>cancel</v-icon>&nbsp;Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout>
        <v-dialog v-model='actualizarGenero' scrollable persistent max-width='300px'>
          <v-card>
            <v-toolbar dark color="primary" right>
                <v-toolbar-title><h4>{{$t('dashboard.upd_info')}}</h4>
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout wrap>
                <v-flex>
                  <v-select
                    :no-data-text="$t('comun.sin_datos')"
                    v-model="genero"
                    :items="itemsGenero"
                    item-text='tipgen_descripcion'
                    item-value='tipgen_codigo'
                    :label="$t('dashboard.genero')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12 md6></v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color='primary' @click='actualizarDatos()'>
                <v-icon>check</v-icon>&nbsp;{{$t('comun.guardar')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-if="tipo_usuario === 'usuario_externo' && this.documentoIdentificacion === 1" v-model='actualizarDatosPer' scrollable persistent max-width='700px'>
          <v-card>
            <v-toolbar dark color="primary">
           <v-card-title><span class="headline"><h4>Debe modificar y contrastar sus datos</h4></span>
          </v-card-title>
          <v-spacer></v-spacer>
        </v-toolbar> 
      <v-card-text class="py-0">
        <v-form v-model='valid' ref='formPer' lazy-validation>
          <v-container>
              <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                <v-select
                    v-model='documentoIdentificacion'
                    :items='itemsDocId'
                    item-text='tipdoc_descripcion'
                    item-value='tipdoc_codigo'
                    :disabled='!modificar'
                    label='Documento de Identificación*'
                    @change='tipoDocumento()'
                    :rules='dRules'
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if='this.documentoIdentificacion===1'>
                <v-flex xs12 sm6 md6>
                  <v-tooltip color="secondary" top>
                    <template v-slot:activator='{ on }'>
                      <v-text-field
                        v-on='on'
                        v-model='nroDocumento'
                        label='Número de Documento*'
                        maxlength='25'
                        :disabled='!modificarNroDoc'
                        :rules='ciRules'                  
                      ></v-text-field>
                    </template>
                  <span>Digite el número del documento de identificación (SIN ESPACIOS VACIOS)</span>
                </v-tooltip>
                </v-flex>
                <v-flex sm6 md6>
                  <v-tooltip color="secondary" top>
                    <template v-slot:activator='{ on }'>
                      <v-text-field
                        v-on='on'
                        v-model='complemento'
                        label='Complemento SEGIP'
                        maxlength='2'
                        :rules='complementoRules'
                        :disabled='!modificarComplemento'
                        class="text-normal"
                      ></v-text-field>
                    </template>
                    <span>Complemento alfanumérico otorgado por el SEGIP, por ejemplo "1K", no corresponde a la extensión.</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <div v-if='this.documentoIdentificacion===3'>
                <v-layout wrap>      
                  <v-flex xs12 sm4 md4>
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator='{ on }'>
                          <v-text-field
                            v-on='on'
                            v-model='prefijo'
                            label='Prefijo Alfanumérico Pasaporte*'
                            maxlength='25'                   
                          ></v-text-field>
                        </template>
                        <span>Digite el número de prefijo (SIN ESPACIOS VACIOS)</span>
                    </v-tooltip>  
                  </v-flex>
                  <v-flex xs12 sm4 md4> 
                    <v-tooltip color="secondary" top>
                    <template v-slot:activator='{ on }'>
                      <v-text-field
                        v-on='on'
                        v-model='nroPasaporte'
                        label='Número de Pasaporte*'
                        :disabled='!modificar'
                        maxlength='25'
                        :rules='pasaporteRules'
                      ></v-text-field>
                    </template>
                    <span>Digite el número del pasaporte (SIN ESPACIOS VACIOS) por Ejemplo A-12345</span>
                  </v-tooltip>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator='{ on }'>
                          <v-text-field
                            v-on='on'
                            v-model='sufijo'
                            label='Sufijo Alfanumérico Pasaporte*'
                            maxlength='4'                  
                          ></v-text-field>
                        </template>
                        <span>Digite el número de sufijo (SIN ESPACIOS VACIOS)</span>
                    </v-tooltip>  
                  </v-flex>
                </v-layout>
              </div>
              <v-layout wrap>
                <v-flex xs12 sm12 md6>
                  <v-text-field
                    v-model='apellidoPaterno'
                    label='Apellido Paterno'
                    maxlength='60'
                    :disabled='!modificarPaterno'
                    @keyup="apellidoPaterno = apellidoPaterno ? apellidoPaterno.replace(/[%#{}*]/g, '') : ''"
                    class='my-input'
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-text-field
                    v-model='apellidoMaterno'
                    label='Apellido Materno'
                    maxlength='60'
                    :disabled='!modificarMaterno'
                    @keyup="apellidoMaterno = apellidoMaterno ? apellidoMaterno.replace(/[%#{}*]/g, '') : ''"
                    class='my-input'
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm12 md6>
                  <v-tooltip color="secondary" top>
                    <template v-slot:activator='{ on }'>
                      <v-text-field
                        v-on='on'
                        v-model='nombres'
                        label='Nombres*'
                        :rules='dRules'
                        required
                        maxlength='100'
                        :disabled='!modificarNombre'
                        @keyup="nombres = nombres ? nombres.replace(/[%#{}*]/g, '') : ''"
                        class='my-input'
                      ></v-text-field>
                    </template>
                    <span>Revise los Apellidos y Nombres que esten transcritos correctamente .</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <br />
              <v-layout wrap>
                <v-flex sm6 md6>
                  <v-select
                  :no-data-text="$t('comun.sin_datos')"
                    v-model='tipoNacionalidad'
                    :items='itemTipoNacionalidad'
                    item-text='tipoNacionalidad_descripcion'
                    item-value='tipoNacionalidad_codigo'
                    label='Nacionalidad*'
                    hint='Dato opcional para validar'
                    persistent-hint
                    teal
                    :rules='dRules'
                  ></v-select>
                </v-flex>
                <v-flex sm6 md6>
                  <global-date-input-picker
                    v-model="dateNac" :hint="'Formato : DD/MM/AAAA (Dato opcional para validar)'" :disabled='!modificarFechaNac' label="Fecha de Nacimiento*">
                  </global-date-input-picker> 
                </v-flex>
              </v-layout>
              <br>
              <v-layout wrap>
                <b>Digite la letras y/o números que aparecen en la imagen </b>
                <v-layout row wrap>
                  <v-flex md3 offset-md1>
                    <img
                      :src="imgb64"
                      alt="Bolivia">
                  </v-flex>
                  <v-flex md4 offset-md1>
                    <v-text-field
                      v-model="form.captcha"
                      :rules='this.useCaptcha ? dRules : []'
                      label='Respuesta'
                      :required="this.useCaptcha"
                      :maxlength="this.lengthCaptcha"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md1>
                    <v-icon large @click="crearImagenCaptcha()">cached</v-icon>                  
                  </v-flex>
                </v-layout>  
              </v-layout>
              <v-layout wrap>
                <v-flex sm12 md12>
                  <v-subheader>
                    <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                  </v-subheader>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="tamanioBoton" :loading='loadingContrastar' color='primary' @click='contrastar()' v-show="this.desabilitaBoton">
                  <v-icon>check</v-icon>&nbsp;Contrastar
                </v-btn>
                <v-btn class="tamanioBoton" :loading='loadingModificar' color='primary' v-show="this.modificarDato" @click='actualizarDatosMod()'>
                <v-icon>check</v-icon>&nbsp;Modificar
                </v-btn>
                <v-btn class="tamanioBoton" color='error' @click='salir()'>
                <v-icon>highlight_off</v-icon>&nbsp;En otro momento
                </v-btn>
             </v-card-actions>
           </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout>
        <v-dialog v-model='actualizarDatosPersonales' scrollable persistent max-width='500px'>
          <v-card>
            <v-toolbar dark color="warning" right>
                <h4>{{$t('dashboard.upd_datos_personales')}}</h4>
            </v-toolbar>
            <v-card-text>
              <v-layout wrap>
                {{$t('dashboard.mensaje_datos_err')}}
              </v-layout>
              <br/>
              <v-layout wrap v-show="usuario.observaciones.perdec_nombres !== 0">
                <v-flex xs12 sm6 md6>
                 Dato Segip: <strong>{{usuario.nombres}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md6>
                 Dato a Corregir: {{usuario.observaciones.perdec_nombres}}
                </v-flex>
              </v-layout>
              <v-layout wrap v-show="usuario.observaciones.perdec_appaterno !== 0">
                <v-flex xs12 sm6 md6>
                 Dato Segip: <strong>{{usuario.primer_apellido}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md6>
                 Dato a corregir: {{usuario.observaciones.perdec_appaterno}}
                </v-flex>
              </v-layout>
              <v-layout wrap v-show="usuario.observaciones.perdec_apmaterno !== 0">
                <v-flex xs12 sm6 md6>
                 Dato Segip: <strong>{{usuario.segundo_apellido}}</strong>
                </v-flex>
                <v-flex xs12 sm6 md6>
                Dato a corregir:  {{usuario.observaciones.perdec_apmaterno}}
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color='primary' @click='actualizarDatoPersonales()'>
                <v-icon>check</v-icon>&nbsp;{{$t('comun.actualizar')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="advertencia" max-width="290">
          <v-card>
             <v-toolbar dark color="warning" right>
                   <v-toolbar-title><h4><v-icon color="error">warning</v-icon>Advertencia</h4></v-toolbar-title>
                </v-toolbar>
    
            <v-card-text>
             <p align='justify'>Favor verifique que sus datos se encuentren correctos, en caso de tener algún error, favor apersonesé a oficinas de la Contraloría General del Estado
              para la modificación de sus datos.</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                text
                @click="advertencia = false"
              ><v-icon>check</v-icon>&nbsp;Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-layout>
    <v-dialog v-model="dialogFirma" scrollable width="500">
      <v-card>
        <v-toolbar dark color='primary'>
          <v-toolbar-title><h4><v-icon>info</v-icon> INFORMACIÓN</h4></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogFirma = false, datos_recepcion = {}">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <br>
          <p align='justify'>
            Su declaración jurada con número de certificado {{ datos_recepcion.decjur_numero_certificado_departamento }} ha sido recepcionada correctamente, actualmente está en proceso el almacenamiento de su certificado y formulario digital en nuestro archivo digital, debido a que en estos momentos tenemos muchas solicitudes esto podría demorar unos minutos, por favor vuelva a intentar más tarde.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogFirma = false, datos_recepcion = {}"><v-icon>cancel</v-icon>&nbsp;Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogComunicado" persistent max-width="800">
      <v-card class="px-3">
        <v-card-title class="justify-center">
          <h3 class="mt-2" style="color: #01579B;"><strong>Bienvenido al Sistema de Declaraciones Juradas de Bienes y Rentas</strong></h3>
        </v-card-title>
        <hr class="ma-2" color="#34699a">
        <v-card-text>
          <p style="text-align: justify;">
            <b>Políticas de control de accesos</b>
          </p>
          <p style="text-align: justify;">
            Las contraseñas deberán ser suficientemente complejas y difícilmente adivinables por terceros, evitando el uso del propio identificador (cuenta de usuario) como contraseña o palabras sencillas, el nombre propio, fecha de nacimiento etc. y deberán ser actualizados de manera periódica.
          </p>
          <p style="text-align: justify;">
            El declarante es responsable del resguardo y confidencialidad de sus credenciales de acceso (usuario, contraseña o código de su tarjeta DJBR), en caso de que las mismas sean conocidas fortuita o fraudulentamente por personas no autorizadas, deberá proceder inmediatamente a su cambio.
          </p>
          <p style="text-align: justify;">
             Sin importar las circunstancias, la contraseña o el código de la tarjeta DJBR nunca se deben compartir o revelar; realizar esta acción responsabiliza al declarante de todas las acciones que se realizasen con el mismo. 
          </p>
          <p style="text-align: justify;">
            El declarante es responsable de todas las acciones realizadas en el sistema con sus credenciales de acceso.
          </p>
          <p style="text-align: justify; font-size: 12px;">
            Texto extraído del Procedimiento para el llenado, presentación, recepción y verificación de la Declaración Jurada de Bienes y Rentas, punto 7.2.3.
          </p>
          <p style="text-align: justify;">
            Por seguridad, <b>NO</b> guarde su contraseña en el gestor de contraseñas del navegador donde hace uso del sistema.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogComunicado = false">ACEPTAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import validate from '@/common/mixins/validate';
import Captcha from '../../components/portal/mixins/captcha.js';
import Segip from '../../components/djbrd/mixins/segip.js';
import Parametricas from '../djbrd/mixins/parametricas';
import Auth from '@/components/admin/auth/mixins/auth';
var format = require('date-format');
export default {
  mixins: [ Auth, Parametricas, Captcha, Segip, validate ],
  mounted () {
    this.$root.$on('clickedNavBar', () => {
      this.obtenerDatosStorage().then(respuesta => {
        if (this.$storage.exist('user')) {
          this.usuario = this.$storage.get('user');
        }
      });
    });
  },
  async created () {
    if (this.$storage.exist('user')) {
      await this.obtenerDeclaraciones();
      this.usuario = this.$storage.get('user');
      if (this.usuario.email.indexOf('|') !== -1) {
        var str = this.usuario.email;
        var res = str.split('|');
        this.usuario.email = res[0];
        this.$storage.set('user', this.usuario);
      }
      let datosPersonalesOk = this.usuario.observaciones.perdec_appaterno !== 0 || this.usuario.observaciones.perdec_apmaterno !== 0 || this.usuario.observaciones.perdec_nombres !== 0;
      this.actualizarDatosPersonales = !this.actualizarGenero && datosPersonalesOk;
      await this.obtenerEstadoDeclaracion().then(async respuesta => {
        if (respuesta.finalizado) {
          this.estadoDeclaracion = respuesta.data.cod_estado;
          this.sistema_recepcion = respuesta.data.sistema_recepcion;
          this.actualizarGenero = respuesta.data.genero === -1;
        }
      });
      // this.navBarEmmit();
      let token = this.$util.parseJwt(this.$storage.get('token'));
      this.tipo_usuario = token.tipo;
      this.obtieneComunicado();
      // if (this.estadoDeclaracion === -1 || this.estadoDeclaracion === 3) {
      //   this.obtieneTipoDocumento();
      //   this.cargarDepartamentos();
      //   if (this.itemsPaises.length === 0) {
      //     this.obtenerPaisesParametrica().then(respuesta => {
      //       this.itemsPaises = respuesta.datos;
      //     });
      //   }
      //   if (this.motivoDeclaracionItemsInicio.length === 0) {
      //     this.obtenerMotivoDeclaracionParametrica().then(respuesta => {
      //       this.motivoDeclaracionItemsInicio = respuesta.datos;
      //       let i = 0;
      //       this.motivoDeclaracionItemsInicio.forEach(element => {
      //         if (element.motdec_codigo === 7 && this.datos.length === 0) {
      //           this.motivoDeclaracionItemsInicio.splice(i, 1);
      //         }
      //         i++;
      //       });
      //       if (this.tipo_usuario === 'usuario') {
      //         let motivos = [];
      //         this.motivoDeclaracionItemsInicio.forEach(element => {
      //           if (element.motdec_codigo === 1 || element.motdec_codigo === 6 || element.motdec_codigo === 7) {
      //             motivos.push(element);
      //           }
      //           i++;
      //         });
      //         this.motivoDeclaracionItemsInicio = motivos;
      //       }
      //       this.motivoDeclaracionItems = this.motivoDeclaracionItemsInicio;
      //       this.obtenerDescripcionMotivoDeclaracion();
      //     });
      //   }
      // }
      if (this.tipo_usuario === 'usuario_externo') {
        await this.setearDatos();
        await this.verificaContrastacion();
      }
      if (this.estadoDeclaracion === 2 && this.tipo_usuario === 'usuario' && this.sistema_recepcion === 0) {
        this.dialogAtencion = true;
      } else {
        this.dialogAtencion = false;
      }
    }
  },
  data: () => ({
    datos_recepcion: {},
    dialogFirma: false,
    dialogComunicado: false,
    dialogAtencion: false,
    loadingContrastar: false,
    loadingModificar: false,
    advertencia: false,
    usuario: { nombre: '', primer_apellido: '', segundo_apellido: '', tipo_documento: '', nro_documento: '', email: '', celular: '', observaciones: {} },
    rowsPerPageItems: [5, 10, 25, {'text': 'Todo', 'value': -1}],
    menu: false,
    declararComo: null,
    esCapital: null,
    valid: false,
    pais: '',
    codDepartamento: { dep_codigo: 0, dep_descripcion: '' },
    itemsDep: [],
    dato: 'No hay datos disponibles',
    tipo_usuario: '',
    itemsPaises: [],
    localidad: '',
    motivoDeclaracion: 0,
    motivoDeclaracionItems: null,
    motivoDeclaracionItemsInicio: [],
    motdecComentario: '',
    oculatarCalendario: false,
    dRules: [v => !!v || 'Este campo es requerido'],
    textRules: [],
    dateRulesF: [v => ((v || '').length <= 10) || 'El formato requerido DD/MM/AAAA sólo tiene 10 campos'],
    // date: new Date().toISOString().substr(0, 10),
    codEstcivil: 0,
    domDeclaracion: '',
    dirDeclaracion: '',
    fechaDeclaracion: '01/01/1900',
    codDeclaracion: '',
    fechaRectificacionFormat: new Date().toISOString().substr(0, 10),
    pais2: 'BOLIVIA',
    estadoDeclaracion: 0,
    sistema_recepcion: null,
    actualizarGenero: false,
    actualizarDatosPersonales: false,
    datos: [],
    dialog: false,
    actualizarDatosPer: false,
    dialogHabilita: false,
    date: '',
    dialogHabilitar: false,
    fechaActual: new Date().toISOString().substr(0, 10),
    nro: 0,
    headers: [
      { text: 'Nro', sortable: false, value: 'nro' },
      { text: 'Formulario y Certificado', sortable: false, value: ['id_archivo_dig_form', 'id_archivo_dig_cert'] },
      { text: 'Motivo Declaración', sortable: false, value: 'motdec_descripcion' },
      { text: 'Entidad', sortable: false, value: 'cardec_descripcion_entidad' },
      { text: 'Cargo', sortable: false, value: 'cardec_descripcion_cargo' },
      { text: 'Número de Certificado', sortable: false, value: 'decjur_numero_certificado_departamento' },
      { text: 'Fecha de Recepción', sortable: false, value: 'decjur_fecha_recepcion_formateado' }
    ],
    genero: '',
    itemsGenero: [
      {
        tipgen_codigo: 0,
        tipgen_descripcion: 'FEMENINO'
      },
      {
        tipgen_codigo: 1,
        tipgen_descripcion: 'MASCULINO'
      }
    ],
    // ////
    loadingButton: false,
    menu1: false,
    nroDocumento: '',
    desabilitaBoton: true,
    modificarDato: false,
    complemento: '',
    documentoIdentificacion: '',
    itemsDocId: null,
    nroPasaporte: '',
    nroCiPasaporte: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    dateNac: '',
    nombres: '',
    sufijo: '',
    prefijo: '',
    tipoNacionalidad: 0,
    itemTipoNacionalidad: [
      {
        tipoNacionalidad_descripcion: 'NACIONAL',
        tipoNacionalidad_codigo: '1'
      },
      {
        tipoNacionalidad_descripcion: 'EXTRANJERO',
        tipoNacionalidad_codigo: '2'
      }
    ],
    modificar: false,
    modificarPaterno: false,
    modificarMaterno: false,
    modificarNombre: false,
    modificarFechaNac: false,
    modificarNroDoc: false,
    modificarComplemento: false,
    modificaDocumento: null,
    form: {
      captcha: ''
    },
    segipContrastacion: {
      Complemento: 1,
      ComplementoVisible: 1,
      FechaNacimiento: 1,
      Nombres: 1,
      NumeroDocumento: 1,
      PrimerApellido: 1,
      PegundoApellido: 1
    },
    imgb64: '',
    tokenCaptcha: '',
    useCaptcha: process.env.USE_CAPTCHA,
    lengthCaptcha: process.env.LENGTH_CAPTCHA,
    ciRules: [
      v => !!v || 'Este campo es requerido ci',
      v => /^[0-9]*$/.test(v) || 'En nro de ci no es válido'
    ],
    complementoRules: [
      v => (!/^[CH]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[LP]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[CB]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[OR]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PT]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[TJ]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[SC]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[BN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición'
    ],
    pasaporteRules: [
      v => !!v || 'Este campo es requerido pasaporte',
      v =>
        /^[A-Za-z0-9]{1,4}-[0-9]{1,10}$/.test(v) ||
        'En nro de pasaporte no es válido'
    ],
    observacionesRectificacion: '',
    datosPersonalesExpandibles: true,
    search: '',
    enDescarga: false,
    loading: false,
    loadingArchivos: false,
    bandera_habilitacion: 0
  }),
  methods: {
    async obtieneParametricas () {
      if (this.estadoDeclaracion === -1 || this.estadoDeclaracion === 3) {
        await this.cargarDepartamentos();
        if (this.itemsPaises.length === 0) {
          await this.obtenerPaisesParametrica().then(respuesta => {
            this.itemsPaises = respuesta.datos;
          });
        }
        if (this.motivoDeclaracionItemsInicio.length === 0) {
          await this.obtenerMotivoDeclaracionParametrica().then(async respuesta => {
            this.motivoDeclaracionItemsInicio = respuesta.datos;
            let i = 0;
            this.motivoDeclaracionItemsInicio.forEach(element => {
              if (element.motdec_codigo === 7 && this.datos.length === 0) {
                this.motivoDeclaracionItemsInicio.splice(i, 1);
              }
              i++;
            });
            this.motivoDeclaracionItems = this.motivoDeclaracionItemsInicio;
            await this.obtenerDescripcionMotivoDeclaracion();
          });
        }
      }
    },
    async obtieneFirma (item) {
      this.loading = true;
      await this.obtenerDeclaraciones();
      if (this.datos.length > 0) {
        for (let i in this.datos) {
          if (this.datos[i].decjur_codigo === item.decjur_codigo) {
            if (this.datos[i].id_archivo_dig_form === null || this.datos[i].id_archivo_dig_form === '') {
              this.datos_recepcion = item;
              this.dialogFirma = true;
            }
          }
        }
      }
      setTimeout(() => {
        this.loading = false;
      }, 120000);
    },
    obtieneComunicado () {
      this.dialogComunicado = true;
    },
    async contrastar () {
      if (this.complemento === 'LP' || this.complemento === 'CB' || this.complemento === 'SC' ||
          this.complemento === 'PT' || this.complemento === 'OR' || this.complemento === 'CH' ||
          this.complemento === 'TJ' || this.complemento === 'BN' || this.complemento === 'PN') {
        this.$message['warning']('El complemento no es un departamento de expedición, el complemento puede ser por ejemplo 1234567-1j');
        this.complemento = '';
        this.modificarNroDoc = true;
        this.modificarComplemento = true;
        this.desabilitaBoton = false; // boton contrastar
        this.modificarDato = true; // boton modificar
        this.modificaDocumento = 0;
      }
      if (!(!!this.apellidoPaterno || !!this.apellidoMaterno)) {
        this.$message['warning']('Al menos uno de los apellidos es requerido');
      }
      if (this.$refs.formPer.validate()) {
        this.loadingContrastar = true;
        // let verify = this.verificarCaptcha(this.useCaptcha, this.tokenCaptcha, this.form.captcha);
        // if (verify) {
        let params = {
          tipo_persona: this.tipoNacionalidad,
          NumeroDocumento: this.nroDocumento,
          FechaNacimiento: this.dateNac,
          PrimerApellido: this.apellidoPaterno,
          SegundoApellido: this.apellidoMaterno,
          nombres: this.nombres,
          token: this.tokenCaptcha,
          captcha: this.form.captcha
        };
        if (this.complemento !== '') {
          params.NumeroDocumento = `${this.nroDocumento}-${this.complemento}`;
        }
        let responseSegip = await this.contrastarSegip(params).then(resp => {
          if (resp.err_existente === 0) {
            this.$message['success'](resp.err_mensaje);
            resp.finalizado = true;
          }
          if (resp.err_existente === 1) {
            this.$message['info'](resp.err_mensaje);
            resp.finalizado = false;
          }
          if (resp.error_codigo === 503) {
            this.$message['info']('El servicio de contrastación no está disponible', 'SEGIP', {timeout: 15000});
            this.$message['info']('La modificación de datos debe hacerlo más tarde');
            this.loadingContrastar = false;
            this.desabilitaBoton = true; // boton contrastar
            this.modificarDato = false; // boton modificar
            this.salir();
          }
          return resp;
        }).catch(e => {
          console.log(e);
          this.loadingContrastar = false;
          return e;
        });
        this.segipContrastacion = responseSegip.camposComparados;
        // let estadoSegip = responseSegip.estadoSegip ? responseSegip.estadoSegip : true;
        // if (estadoSegip) {
        if (responseSegip.finalizado) {
          // this.$message[responseSegip.tipo](responseSegip.mensaje[0]);
          this.$service.put(`djbr_registro/contrastacion_segip`).then(response => {
            if (response) {
              this.$message['success']('Los datos se encuentran correctos no se tiene ningún registro para modificar');
              this.loadingContrastar = false;
              this.salir();
            }
          }).catch(e => {
            console.log(e);
            this.loadingContrastar = false;
          });
          if (this.segipContrastacion.PrimerApellido === 2) {
            this.modificarPaterno = true;
            this.desabilitaBoton = false; // boton contrastar
            this.modificarDato = true; // boton modificar
            this.loadingContrastar = false;
          }
          if (this.segipContrastacion.SegundoApellido === 2) {
            this.modificarMaterno = true;
            this.desabilitaBoton = false; // boton contrastar
            this.modificarDato = true; // boton modificar
            this.loadingContrastar = false;
          }
        } else {
          this.loadingContrastar = false;
          this.tokenCaptcha = '';
          this.form.captcha = '';
          this.crearImagenCaptcha();
          if (responseSegip.mensaje) {
            responseSegip.mensaje.forEach(msj => {
              this.$message[responseSegip.tipo](msj);
              this.crearImagenCaptcha();
              if (msj === 'No se encontró el registro') {
                this.advertencia = true;
              }
            });
          }
          if (this.segipContrastacion && this.segipContrastacion.PrimerApellido === 0) {
            this.modificarPaterno = true;
            this.desabilitaBoton = false; // boton contrastar
            this.modificarDato = true; // boton modificar
          }
          if (this.segipContrastacion && this.segipContrastacion.SegundoApellido === 0) {
            this.modificarMaterno = true;
            this.desabilitaBoton = false; // boton contrastar
            this.modificarDato = true; // boton modificar
          }
          if (this.segipContrastacion && this.segipContrastacion.Nombres === 0) {
            this.modificarNombre = true;
            this.desabilitaBoton = false; // boton contrastar
            this.modificarDato = true; // boton modificar
          }
          if (this.segipContrastacion && this.segipContrastacion.FechaNacimiento === 0) {
            this.modificarFechaNac = true;
            this.desabilitaBoton = false; // boton contrastar
            this.modificarDato = true; // boton modificar
          }
        }
        // } else {
        //   this.crearImagenCaptcha();
        //   this.$message['warning']('El código ingresado no es correcto');
        //   this.loadingContrastar = false;
        //   this.respuesta.estado = '';
        // }
      } else {
        this.$message['warning']('Favor Ingrese los Datos Obligatorios.');
      }
    },
    async actualizarDatosMod () {
      if (this.$refs.formPer.validate()) {
        this.loadingModificar = true;
        // let verify = this.verificarCaptcha(this.useCaptcha, this.tokenCaptcha, this.form.captcha);
        // if (verify) {
        this.$storage.remove('user');
        let params = {
          tipo_persona: this.tipoNacionalidad,
          NumeroDocumento: this.nroDocumento,
          FechaNacimiento: this.dateNac,
          PrimerApellido: this.apellidoPaterno,
          SegundoApellido: this.apellidoMaterno,
          nombres: this.nombres,
          token: this.tokenCaptcha,
          captcha: this.form.captcha
        };
        if (this.complemento !== '') {
          params.NumeroDocumento = `${this.nroDocumento}-${this.complemento}`;
        }
        let responseSegip = await this.contrastarSegip(params).then(resp => {
          if (resp.err_existente === 0) {
            this.$message['success'](resp.err_mensaje);
            resp.finalizado = true;
          }
          if (resp.err_existente === 1) {
            this.$message['info'](resp.err_mensaje);
            resp.finalizado = false;
          }
          return resp;
        }).catch(e => {
          console.log(e);
          this.loadingModificar = false;
          return e;
        });
        // let estadoSegip = responseSegip.estadoSegip ? responseSegip.estadoSegip : true;
        if (responseSegip.finalizado) {
          if (this.modificaDocumento === 0) {
            this.$service.put(`djbr_registro/datos_declarante`, [{valor_actual_prefijo: '', valor_actual_numero_documento: this.nroDocumento, valor_actual_sufijo: this.complemento, valor_actual_tipo_documento: this.documentoIdentificacion, tipo_modificacion: 'DOC', relacion: 0, prefijo_pasaporte: '', nro_pasaporte: '', sufijo_pasaporte: ''}]).then(response => {
              if (response) {
                if (response.err_existente === 0) {
                  this.usuario.nro_documento = this.nroDocumento.toUpperCase();
                  this.$storage.set('user', this.usuario);
                  this.$message['success'](response.pila_respuesta.err_mensaje);
                  this.loadingModificar = false;
                  this.modificarNroDoc = false;
                  this.modificarComplemento = false;
                  this.desabilitaBoton = true; // boton contrastar
                  this.modificarDato = false; // boton modificar
                  this.salir();
                } else {
                  this.$message['error'](response.err_mensaje);
                  this.loadingModificar = false;
                }
              } else {
                this.crearImagenCaptcha();
                this.loadingModificar = false;
              }
            });
          }
          if (this.segipContrastacion.PrimerApellido === 0 || this.segipContrastacion.PrimerApellido === 2) {
            this.$service.put(`djbr_registro/datos_declarante`, [{valor_actual: this.apellidoPaterno, tipo_modificacion: 'MAP'}]).then(response => {
              if (response) {
                if (response.error_existente === 0) {
                  this.usuario.primer_apellido = this.apellidoPaterno.toUpperCase();
                  this.$storage.set('user', this.usuario);
                  this.$message['success'](response.pila_respuesta.err_mensaje);
                  this.loadingModificar = false;
                  this.modificarPaterno = false;
                  this.desabilitaBoton = true; // boton contrastar
                  this.modificarDato = false; // boton modificar
                  this.salir();
                } else {
                  this.$message['error'](response.error_mensaje);
                  this.loadingModificar = false;
                }
              } else {
                this.crearImagenCaptcha();
                this.loadingModificar = false;
              }
            });
          }
          if (this.segipContrastacion.SegundoApellido === 0 || this.segipContrastacion.SegundoApellido === 2) {
            this.$service.put(`djbr_registro/datos_declarante`, [{valor_actual: this.apellidoMaterno, tipo_modificacion: 'MAM'}]).then(response => {
              if (response) {
                if (response.error_existente === 0) {
                  this.usuario.segundo_apellido = this.apellidoMaterno.toUpperCase();
                  this.$storage.set('user', this.usuario);
                  this.$message['success'](response.pila_respuesta.err_mensaje);
                  this.loadingModificar = false;
                  this.modificarMaterno = false;
                  this.desabilitaBoton = true; // boton contrastar
                  this.modificarDato = false; // boton modificar
                  this.salir();
                } else {
                  this.$message['error'](response.error_mensaje);
                  this.loadingModificar = false;
                }
              }
            });
          }
          if (this.segipContrastacion.Nombres === 0) {
            this.$service.put(`djbr_registro/datos_declarante`, [{valor_actual: this.nombres, tipo_modificacion: 'MNP'}]).then(response => {
              if (response) {
                if (response.error_existente === 0) {
                  this.usuario.nombres = this.nombres.toUpperCase();
                  this.$storage.set('user', this.usuario);
                  this.$message['success'](response.err_mensaje);
                  this.loadingModificar = false;
                  this.modificarNombre = false;
                  this.desabilitaBoton = true; // boton contrastar
                  this.modificarDato = false; // boton modificar
                  this.salir();
                } else {
                  this.$message['error'](response.error_mensaje);
                  this.loadingModificar = false;
                }
              }
            });
          }
          if (this.segipContrastacion.FechaNacimiento === 0) {
            this.$service.put(`djbr_registro/datos_declarante`, [{valor_actual: this.dateNac, tipo_modificacion: 'MFN'}]).then(response => {
              if (response) {
                if (response.error_existente === 0) {
                  this.usuario.fecha_nacimiento = this.parseDate(this.dateNac);
                  this.$storage.set('user', this.usuario);
                  this.$message['success'](response.err_mensaje);
                  this.loadingModificar = false;
                  this.modificarFechaNac = false;
                  this.desabilitaBoton = true; // boton contrastar
                  this.modificarDato = false; // boton modificar
                  this.salir();
                } else {
                  this.$message['error'](response.error_mensaje);
                  this.loadingModificar = false;
                }
              }
            });
          }
        } else {
          this.loadingModificar = false;
          this.desabilitaBoton = false; // boton contrastar
          this.modificarDato = true; // boton modificar
          if (responseSegip.mensaje) {
            responseSegip.mensaje.forEach(msj => {
              this.$message[responseSegip.tipo](msj);
            });
          }
          this.crearImagenCaptcha();
          if (this.segipContrastacion && this.segipContrastacion.PrimerApellido === 0) {
            this.modificarPaterno = true;
          }
          if (this.segipContrastacion && this.segipContrastacion.SegundoApellido === 0) {
            this.modificarMaterno = true;
          }
          if (this.segipContrastacion && this.segipContrastacion.Nombres === 0) {
            this.modificarNombre = true;
          }
          if (this.segipContrastacion && this.segipContrastacion.FechaNacimiento === 0) {
            this.modificarFechaNac = true;
          }
        }
        // } else {
        //   this.crearImagenCaptcha();
        //   this.$message['warning']('El codigo ingresado no es correcto');
        //   this.loadingModificar = false;
        //   this.respuesta.estado = '';
        // }
      } else {
        this.$message['warning']('Favor Ingrese los Datos Obligatorios.');
      }
    },
    async verificaContrastacion () {
      if (this.usuario.segip === 0) {
        await this.obtieneTipoDocumento();
        await this.crearImagenCaptcha();
        this.actualizarDatosPer = true;
      } else {
        this.actualizarDatosPer = false;
      }
    },
    tipoDocumento () {
      if (this.documentoIdentificacion === 1) {
        this.nroDocumento = this.nroPasaporte;
        this.nroPasaporte = '';
      } else {
        this.nroPasaporte = this.nroDocumento;
        this.nroDocumento = '';
      }
    },
    obtieneTipoDocumento () {
      this.$service.get('tipos_documentos', {}).then(res => {
        if (res) {
          this.itemsDocId = res;
        }
      });
    },
    setearDatos () {
      this.documentoIdentificacion = this.usuario.tipo_documento;
      var str = this.usuario.perdec_docidentidad;
      var res = str.split('_');
      this.nroDocumento = res[1];
      this.complemento = res[2];
      this.apellidoPaterno = this.usuario.primer_apellido;
      this.apellidoMaterno = this.usuario.segundo_apellido;
      this.nombres = this.usuario.nombres;
      this.dateNac = this.$util.formatDateDDMMYYYY(this.formatFechaNacimiento);
    },
    async crearImagenCaptcha () {
      this.form.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    },
    cargarDepartamentos () {
      this.$service
        .get(`departamentos`, {})
        .then(response => {
          if (response) {
            this.itemsDep = response;
          }
        });
    },
    salir () {
      this.usuario.segip = 1;
      this.$storage.set('user', this.usuario);
      this.actualizarDatosPer = false;
      this.desabilitaBoton = true; // boton contrastar
      this.modificarDato = false; // boton modificar
      this.modificarPaterno = false;
      this.modificarMaterno = false;
      this.modificarNombre = false;
      this.modificarFechaNac = false;
      this.tokenCaptcha = '';
      this.form.captcha = '';
      this.$refs.formPer.resetValidation();
      this.crearImagenCaptcha();
    },
    async verificarEstadoDeclaracion () {
      await this.obtieneParametricas();
      this.dialog = true;
    },
    verificaHabilitacion  () {
      this.$service.get('djbr_registro/validar_habilita_declaracion', {}).then(response => {
        if (response) {
          if (response.err_existente === 0) {
            this.bandera_habilitacion = 0;
          } else {
            this.bandera_habilitacion = 1;
          }
          this.dialogHabilitar = true;
        }
      }).catch(error => {
        this.$message['warning'](error.error_mensaje);
      });
    },
    habilitarDeclaracion () {
      this.$service.post('djbr_registro/habilita_declaracion', {}).then(response => {
        if (response.err_existente === 0) {
          this.$message['success'](response.err_mensaje);
          this.obtenerEstadoDeclaracion().then(respuesta => {
            if (respuesta.finalizado) {
              this.estadoDeclaracion = respuesta.data.cod_estado;
            }
          });
          this.navBarEmmit();
          this.$router.push('/datos-generales');
        } else {
          this.$message['warning'](response.err_mensaje);
        }
      });
    },
    obtenerDescripcionMotivoDeclaracion () {
      this.motivoDeclaracionItems.forEach(element => {
        if (this.motivoDeclaracion === element.motdec_codigo) {
          this.motdecComentario = element.motdec_comentario.replace('<B>', '').replace('</B>', '');
          this.oculatarCalendario = false;
          if (element.motdec_descripcion === 'RECTIFICACIÓN DE DECLARACIÓN JURADA DE BIENES Y RENTAS') {
            this.oculatarCalendario = true;
          }
        }
      });
    },
    cambiaDpto () {
      if (this.declararComo === '1') {
        this.pais2 = 'BOLIVIA';
      }
    },
    clickGuardaDeclaracion () {
      if (this.$refs.form.validate()) {
        this.loadingButton = true;
        if (this.declararComo === '2') {
          this.esCapital = 2;
          this.codDepartamento.dep_codigo = 2;
        } else {
          this.pais = 'BOL';
        }
        if (this.tipo_usuario !== 'usuario_externo') {
          this.codDepartamento.dep_codigo = 2;
        }
        if (this.motivoDeclaracion === 7) {
          if (Date.parse(this.$util.formatDateYYYYMMDD(this.date)) <= Date.parse(this.fechaActual)) {
            let dateParts = this.date.split('/');
            this.fechaDeclaracion = format.asString('yyyy-MM-dd', new Date(`${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`));
            let params = {
              cod_motivo: this.motivoDeclaracion,
              declara_nacional_extranjero: this.declararComo,
              cod_capital: this.esCapital,
              pais: this.pais,
              localidad: this.localidad,
              cod_departamento: this.codDepartamento.dep_codigo,
              cod_estcivil: this.codEstcivil,
              dom_declaracion: this.domDeclaracion,
              dir_declaracion: this.observacionesRectificacion,
              fecha_declaracion: this.fechaDeclaracion
            };
            this.$service
            .post(`djbr_registro/declaracion_jurada`, params)
            .then(response => {
              if (response) {
                if (response.err_existente === 0) {
                  this.loadingButton = false;
                  this.$message['success'](response.err_mensaje);
                  this.$storage.set('codigoPais', this.pais);
                  this.dialog = false;
                  this.obtenerEstadoDeclaracion().then(respuesta => {
                    if (respuesta.finalizado) {
                      this.estadoDeclaracion = respuesta.data.cod_estado;
                    }
                  });
                  this.navBarEmmit();
                  this.$router.push('/datos-generales');
                  this.disabledForm = true;
                } else {
                  this.loadingButton = false;
                  this.$message['error'](response.err_mensaje);
                }
              }
            })
            .catch(e => {
              console.log(e);
              this.loadingButton = false;
            });
          } else {
            this.$message['warning']('La fecha de rectificación no puede estar vacia y no debe ser futura');
            this.loadingButton = false;
          }
        } else {
          this.fechaDeclaracion = format.asString('yyyy-MM-dd', new Date());
          let params = {
            cod_motivo: this.motivoDeclaracion,
            declara_nacional_extranjero: this.declararComo,
            cod_capital: this.esCapital,
            pais: this.pais,
            localidad: this.localidad,
            cod_departamento: this.codDepartamento.dep_codigo,
            cod_estcivil: this.codEstcivil,
            dom_declaracion: this.domDeclaracion,
            dir_declaracion: this.observacionesRectificacion,
            fecha_declaracion: this.fechaDeclaracion
          };
          this.$service
        .post(`djbr_registro/declaracion_jurada`, params)
        .then(response => {
          if (response) {
            if (response.err_existente === 0) {
              this.loadingButton = false;
              this.$message['success'](response.err_mensaje);
              this.$storage.set('codigoPais', this.pais);
              this.dialog = false;
              this.obtenerEstadoDeclaracion().then(respuesta => {
                if (respuesta.finalizado) {
                  this.estadoDeclaracion = respuesta.data.cod_estado;
                }
              });
              this.navBarEmmit();
              this.$router.push('/datos-generales');
              this.disabledForm = true;
              this.loadingButton = false;
            } else {
              this.$message['error'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
        }
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    clickCancelarDeclaracion () {
      this.dialog = false;
      this.declararComo = null;
      this.motivoDeclaracion = 0;
      this.localidad = '';
      this.codDepartamento = { dep_codigo: 0, dep_descripcion: '' };
      this.$refs.form.resetValidation();
    },
    async obtenerDeclaraciones () {
      await this.$service.get(`djbr_registro/obtieneFinalizados`, {}).then(response => {
        this.nro = 0;
        if (response.length > 0) {
          this.datos = response;
          for (let i = 0; i < this.datos.length; i++) {
            this.datos[i].nro = ++this.nro;
            this.datos[i].decjur_fecha_recepcion_formateado = this.datos[i].decjur_fecha_recepcion.substring(8, 10) + '/' + this.datos[i].decjur_fecha_recepcion.substring(5, 7) + '/' + this.datos[i].decjur_fecha_recepcion.substring(0, 4);
          }
          this.$storage.set('dec', 1);
        } else {
          this.datos = [];
          this.nro = -1;
          this.$storage.set('dec', 0);
        }
      });
    },
    getArchivoDigital (idArchvo, idArchivoDigital, hash) {
      // this.loadingArchivos = true;
      if (this.enDescarga === true) {
        this.$message['warning']('Por Favor aguarde, se esta descargando un archivo');
      } else {
        this.enDescarga = true;
        this.$service.get(`djbr_registro/obtiene_certificado_archivo/${idArchivoDigital}/${hash}`, {}).then(response => {
          if (response) {
            const archivo = response.documento;
            const nombre = idArchvo === 2 ? 'CERTIFICADO' : 'FORMULARIO';
            this.downloadPDF(archivo, nombre);
            this.enDescarga = false;
            this.loadingArchivos = false;
          }
        }).catch(() => {
          this.enDescarga = false;
          this.loadingArchivos = false;
        });
      }
    },
    downloadPDF (pdf, name) {
      const url = window.URL.createObjectURL(this.b64toBlob(pdf, 'application/pdf'));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}_${this.$storage.get('user').nro_documento}.pdf`);
      document.body.appendChild(link);
      link.click();
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    actualizarDatos () {
      this.$service.post(`djbr_registro/actualiza_genero`, {genero: this.genero}).then(response => {
        if (response) {
          if (response.err_existente === 0) {
            this.$message['success'](response.err_mensaje);
            this.actualizarGenero = false;
            this.actualizarDatosPersonales = this.usuario.observaciones.perdec_appaterno !== 0 || this.usuario.observaciones.perdec_apmaterno !== 0 || this.usuario.observaciones.perdec_nombres !== 0;
          } else {
            this.$message['warning'](response.err_mensaje);
          }
        }
      });
    },
    actualizarDatoPersonales () {
      this.$storage.remove('user');
      if (this.usuario.observaciones.perdec_nombres !== 0) {
        this.actualizarDatosPersonalesService(this.usuario.nombres, 'MNP');
      }
      if (this.usuario.observaciones.perdec_appaterno !== 0) {
        this.actualizarDatosPersonalesService(this.usuario.primer_apellido, 'MAP');
      }
      if (this.usuario.observaciones.perdec_apmaterno !== 0) {
        this.actualizarDatosPersonalesService(this.usuario.segundo_apellido, 'MAM');
      }
      this.usuario.observaciones.perdec_appaterno = 0;
      this.usuario.observaciones.perdec_apmaterno = 0;
      this.usuario.observaciones.perdec_nombres = 0;
      this.$storage.set('user', this.usuario);
      // this.logout();
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    formatDateF (dateNac) {
      if (!dateNac) return null;
      const [year, month, day] = this.dateNac.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDateF (dateNac) {
      if (!dateNac) return null;
      const [day, month, year] = dateNac.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    actualizarDatosPersonalesService (valorActual, tipoModificacion) {
      let body = {
        valor_actual: valorActual,
        tipo_modificacion: tipoModificacion
      };
      this.$service.post(`djbr_registro/actualiza_datos_declarante`, body).then(response => {
        if (response) {
          if (response.err_existente === 0) {
            this.$message['success'](response.err_mensaje);
            this.actualizarDatosPersonales = false;
          } else {
            this.$message['error'](response.err_mensaje);
          }
        }
      });
    }
  },
  computed: {
    fechaRectificacion () {
      if (!this.date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    formatFechaRecepcion (fechaRecepcion) {
      if (!this.fechaRecepcion) return null;
      const [year, month, day] = this.fechaRecepcion.split('-');
      return `${day}/${month}/${year}`;
    },
    formatFechaNacimiento () {
      if (!this.usuario.fecha_nacimiento) return null;
      const [year, month, day] = this.usuario.fecha_nacimiento.split('-');
      return `${day}/${month}/${year}`;
    }
  }
};
</script>

<style lang='scss' scoped>
.word-break {
  word-break: break-all;
}
.layout {
  flex: 0 1 auto!important;
}
.continuar {
  color: #fff !important;
  background-color: rgb(137, 174, 37) !important;
  border-color: rgb(137, 174, 37) !important;
}
.card-outlined{
  border: 1px solid #aaa;
  border-radius: 12px;
}
.account {
  background-size: cover;

  .account-info {
    background-color: rgba(146, 122, 122, 0.8);
    color: #777;
    padding: 20px;

    p {
      margin-bottom: 5px;
    }
  }

  .v-card__actions {
    padding: 15px;
    background-color: white;
  }
}
.tab-title {
  color: black;
}
.tab-title-hab {
  color: white;
}
@media (max-width: 600px) {
  .tab-title {
    display: none;
  }
  .tab-title-hab {
    display: none;
  }  
  .display-3 {
      font-size: 44px !important;
      font-weight: 400;
      line-height: 0.9 !important;
      letter-spacing: -0.02em !important;
      font-family: 'Roboto', sans-serif !important;
  }
  .continuar {
    color: #fff !important;
    background-color: rgb(137, 174, 37) !important;
    border-color: rgb(137, 174, 37) !important;
    margin-bottom: 10px;
    font-size: 0.9rem;
    font-weight: 500;
  }
  .headline {
    font-size: 21px !important;
    font-weight: 400;
    line-height: 21px !important;
    letter-spacing: normal !important;
    font-family: 'Roboto', sans-serif !important;
  }
  .title {
    font-size: 16px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/djbrd/dashboard.vue